import React from "react";
import { observer } from "mobx-react";
import { AiSearchToolCallCreateStore } from "../../store";
import { AiSearchToolCallCreateForm } from "./AiSearchToolCallCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type AiSearchToolCallCreateProps = {
  aiSearchToolCallCreateStore: AiSearchToolCallCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AiSearchToolCallCreate: React.FC<AiSearchToolCallCreateProps> =
  observer(
    ({ aiSearchToolCallCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={aiSearchToolCallCreateStore.isSaving} />
          <AiSearchToolCallCreateForm
            aiSearchToolCallCreateStore={aiSearchToolCallCreateStore}
            sequenceError={aiSearchToolCallCreateStore.errors.sequence?.message}
            onSequenceChange={(value: number) => {
              aiSearchToolCallCreateStore.setSequenceValue(value);
            }}
            sequence={aiSearchToolCallCreateStore.entityValues.sequence}
            toolNameError={aiSearchToolCallCreateStore.errors.toolName?.message}
            onToolNameChange={(value: string) => {
              aiSearchToolCallCreateStore.setToolNameValue(value);
            }}
            toolName={aiSearchToolCallCreateStore.entityValues.toolName}
            patternError={aiSearchToolCallCreateStore.errors.pattern?.message}
            onPatternChange={(value: string) => {
              aiSearchToolCallCreateStore.setPatternValue(value);
            }}
            pattern={aiSearchToolCallCreateStore.entityValues.pattern}
            navigationPathError={
              aiSearchToolCallCreateStore.errors.navigationPath?.message
            }
            onNavigationPathChange={(value: string) => {
              aiSearchToolCallCreateStore.setNavigationPathValue(value);
            }}
            navigationPath={
              aiSearchToolCallCreateStore.entityValues.navigationPath
            }
            toolArgumentsError={
              aiSearchToolCallCreateStore.errors.toolArguments?.message
            }
            onToolArgumentsChange={(value: string) => {
              aiSearchToolCallCreateStore.setToolArgumentsValue(value);
            }}
            toolArguments={
              aiSearchToolCallCreateStore.entityValues.toolArguments
            }
            resultError={aiSearchToolCallCreateStore.errors.result?.message}
            onResultChange={(value: string) => {
              aiSearchToolCallCreateStore.setResultValue(value);
            }}
            result={aiSearchToolCallCreateStore.entityValues.result}
            durationMsError={
              aiSearchToolCallCreateStore.errors.durationMs?.message
            }
            onDurationMsChange={(value: number) => {
              aiSearchToolCallCreateStore.setDurationMsValue(value);
            }}
            durationMs={aiSearchToolCallCreateStore.entityValues.durationMs}
            successError={aiSearchToolCallCreateStore.errors.success?.message}
            onSuccessChange={(value: boolean) => {
              aiSearchToolCallCreateStore.setSuccessValue(value);
            }}
            success={aiSearchToolCallCreateStore.entityValues.success}
            errorMessageError={
              aiSearchToolCallCreateStore.errors.errorMessage?.message
            }
            onErrorMessageChange={(value: string) => {
              aiSearchToolCallCreateStore.setErrorMessageValue(value);
            }}
            errorMessage={aiSearchToolCallCreateStore.entityValues.errorMessage}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={aiSearchToolCallCreateStore.isProcessing}
            onSave={() => aiSearchToolCallCreateStore.saveNewAiSearchToolCall()}
            onCancel={() =>
              aiSearchToolCallCreateStore.cancelNewAiSearchToolCall()
            }
          />
          <ErrorDialog
            open={aiSearchToolCallCreateStore.errorDialogOpened}
            title={aiSearchToolCallCreateStore.errorTitle}
            description={aiSearchToolCallCreateStore.errorDescription}
            onClose={() => aiSearchToolCallCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
